import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange, maxVisible = 5 }) => {
    // Si solo hay una página, no mostramos la paginación
    if (totalPages <= 1) return null;

    const getPages = () => {
        const pages = [];
        const half = Math.floor(maxVisible / 2);
        let start = Math.max(1, currentPage - half);
        let end = Math.min(totalPages, start + maxVisible - 1);

        if (end - start < maxVisible - 1) {
            start = Math.max(1, end - maxVisible + 1);
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    const pages = getPages();
    const showFirstButton = pages[0] > 1;
    const showLastButton = pages[pages.length - 1] < totalPages;

    return (
        <div className="flex flex-col items-center gap-3 mt-6 select-none">
            <div className="flex items-center gap-2">
                {/* Botón primera página */}
                {showFirstButton && (
                    <>
                        <button
                            className="px-3 py-2 rounded-lg text-sm font-semibold border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 transition-colors"
                            onClick={() => onPageChange(1)}
                        >
                            1
                        </button>
                        {pages[0] > 2 && <span className="text-gray-400">...</span>}
                    </>
                )}

                {/* Números de página */}
                {pages.map((num) => (
                    <button
                        key={num}
                        onClick={() => onPageChange(num)}
                        className={`px-3 py-2 rounded-lg text-sm font-semibold transition-all border ${
                            currentPage === num
                                ? "bg-blue-600 text-white border-blue-600 shadow-sm"
                                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                        }`}
                    >
                        {num}
                    </button>
                ))}

                {/* Botón última página */}
                {showLastButton && (
                    <>
                        {pages[pages.length - 1] < totalPages - 1 && <span className="text-gray-400">...</span>}
                        <button
                            className="px-3 py-2 rounded-lg text-sm font-semibold border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 transition-colors"
                            onClick={() => onPageChange(totalPages)}
                        >
                            {totalPages}
                        </button>
                    </>
                )}
            </div>

            <div className="flex items-center gap-4">
                {/* Botón anterior */}
                <button
                    className={`px-4 py-2 rounded-lg text-sm font-semibold border border-gray-300 transition-colors ${
                        currentPage === 1
                            ? "text-gray-400 cursor-not-allowed bg-gray-100"
                            : "hover:bg-gray-200 bg-white"
                    }`}
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                >
                    ← Anterior
                </button>

                <span className="text-sm text-gray-600">
                    Página <span className="font-semibold">{currentPage}</span> de <span className="font-semibold">{totalPages}</span>
                </span>

                {/* Botón siguiente */}
                <button
                    className={`px-4 py-2 rounded-lg text-sm font-semibold border border-gray-300 transition-colors ${
                        currentPage === totalPages
                            ? "text-gray-400 cursor-not-allowed bg-gray-100"
                            : "hover:bg-gray-200 bg-white"
                    }`}
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                >
                    Siguiente →
                </button>
            </div>
        </div>
    );
};

export default Pagination;
